import styled from 'styled-components';
import { StyledButton } from '../button_general/ButtonGeneralStyle';

export const ButtonWrap = styled.div`
  &[aria-disabled='true'] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Button = styled(StyledButton)`
  cursor: pointer;
  border: none;
  transition: all 0.2s ease-in-out, padding-inline-end 0.2s ease-in-out;
  background-color: ${({ active }) => (active ? 'red' : '#1785d6')};
  &:hover {
    background-color: ${({ active }) => (active ? 'red' : '#1785d6')} !important;
  }
`;
